export interface EmployeesSearch {
  readonly page: number;
}

export const DEFAULT_EMPLOYEES_SEARCH: EmployeesSearch = { page: 1 };

export function parseEmployeesSearch(
  search: Record<string, unknown>,
): EmployeesSearch {
  const page = Number(search.page);
  return { page: Number.isSafeInteger(page) && page > 0 ? page : 1 };
}
